import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ISTabLayoutComponent } from './is-tab-layout.component';
import { OverflowDirective } from './overflow.directive';

const materialModules = [
    MatIconModule
];

@NgModule({
    declarations: [ISTabLayoutComponent, OverflowDirective],
    imports: [
        CommonModule,
        ...materialModules    
    ],
    exports: [ISTabLayoutComponent],
    providers: [],
})
export class ISTabLayoutModule{}